import { INamingOptions } from '../../types/my-types';

export const dailyCronSchedule = '0 2 * * ? *';
export const weeklyCronSchedule = '0 2 ? * 7 *';

export const separatorOptions = ['-', '_'];

export const scheduleOptions = [
  {
    key: 'per_document',
    title: 'Per Document',
    description: 'Send once per document.',
  },
  {
    key: 'daily',
    title: 'Daily',
    description: 'Send once daily, at the end of the day.',
  },
  {
    key: 'weekly',
    title: 'Weekly',
    description: 'Send once weekly, on Friday at end of the day.',
  },
];

export const aggregratingOptionsList = [
  {
    key: 'one_data_file_per_document',
    title: 'One data file per document',
  },
  {
    key: 'all_documents_in_one_data_file',
    title: 'All documents in one data file',
  },
  {
    key: 'one_data_file_per_training_set',
    title: 'One data file per training set',
  },
];

export const namingOptionsList = [
  {
    key: 'string_literal',
    title: 'String Literal',
  },
  {
    key: 'document_name',
    title: 'Document Name',
  },
  {
    key: 'training_set_label',
    title: 'Training Set Name',
  },
  {
    key: 'publish_date',
    title: 'Publish Date',
  },
];

export const publishDateOptionsList = [
  {
    key: 'YYYY-MM',
    title: 'YYYY-MM',
  },
  {
    key: 'YYYY-MM-DD',
    title: 'YYYY-MM-DD',
  },
];

export const routerConfigJSONRequestBuilder = (
  schedule: string,
  aggregateOption: string,
  namingOptions: INamingOptions[],
  prefix?: string,
  separator: string = '-'
) => {
  const newObj = {
    ...(schedule === 'per_document' && {
      package_trigger: {
        type: 'verification',
      },
    }),

    ...(schedule === 'daily' && {
      package_trigger: {
        type: 'schedule',
        config: {
          type: 'cron',
          expressions: [dailyCronSchedule],
        },
      },
    }),

    ...(schedule === 'weekly' && {
      package_trigger: {
        type: 'schedule',
        config: {
          type: 'cron',
          expressions: [weeklyCronSchedule],
        },
      },
    }),

    data_packaging_config: {
      separator: separator,

      package_format: {
        ...(schedule === 'per_document' && {
          type: 'one_data_file_per_document',
        }),

        ...((schedule === 'daily' || schedule === 'weekly') &&
          aggregateOption === 'one_data_file_per_document' && {
            type: 'one_data_file_per_document'
          }),

        ...((schedule === 'daily' || schedule === 'weekly') &&
          aggregateOption === 'all_documents_in_one_data_file' && {
            type: 'aggregated_data_file',
            options: {
              lookup_value: 'published_at',
              source: 'metadata',
            },
          }),

        ...((schedule === 'daily' || schedule === 'weekly') &&
          aggregateOption === 'one_data_file_per_training_set' && {
            type: 'aggregated_data_file',

            options: {
              lookup_value: 'training_set_id',
              source: 'metadata',
            },
          }),
      },

      naming_formula: [
        ...namingOptions.map((option) => {
          if (option.type === 'string_literal') {
            return option.value;
          } else if (option.type === 'document_name') {
            return {
              lookup_value: 'document.name',
              source: 'metadata',
            };
          } else if (option.type === 'training_set_label') {
            return {
              lookup_value: 'training_set_label',
              source: 'metadata',
            };
          } else if (option.type === 'publish_date') {
            if (option.value === 'YYYY-MM-DD') {
              return {
                lookup_value: 'published_at',
                source: 'metadata',
                configuration: {
                  strftime: '%Y-%m-%d',
                },
              };
            } else {
              return {
                lookup_value: 'published_at',
                source: 'metadata',
                configuration: {
                  strftime: '%Y-%m',
                },
              };
            }
          }
        }),
      ],
    },

    route_prefix: {
      prefix: prefix,
    },

    // Default document naming that should be sent with all requests
    document_naming: {
      naming_formula: [
        {
          lookup_value: 'document.name',
          source: 'metadata',
        },
      ],
    },
  };

  // console.log(JSON.stringify(newObj));
  return JSON.stringify(newObj);
};
